import { useTranslation } from "react-i18next";
import "../../../i18n";
import BrowserFrame from "./BrowserFrame";
import CriteriaRow from "./CriteriaRow";

/**
 * Single subject evaluation mock card (used 4× in USP section).
 * Either `criteria` (list of rubric rows) OR `steps` (list of ✓/✗ checks) is rendered.
 */
function EvalCard({
  urlPath,
  monogram,
  tileStyle,
  subjectName,
  subjectMeta,
  score,
  question,
  answer,
  criteria,
  steps,
  tip,
}) {
  const { t } = useTranslation("marketing");
  return (
    <BrowserFrame domain="app.markszen.com" path={urlPath} dark>
      <div className="ul-eval-card-inner">
        <div className="ul-eval-card-header">
          <div className="ul-eval-subject-info">
            <div className="ul-subj-tile" style={{ width: 34, height: 34, fontSize: 14, ...tileStyle }}>
              {monogram}
            </div>
            <div>
              <div className="ul-subject-name">{subjectName}</div>
              <div className="ul-subject-meta">{subjectMeta}</div>
            </div>
          </div>
          <div className="ul-score-pill">{score}</div>
        </div>
        <div className="ul-eval-question-label">{t("evaluation.questionLabel")}</div>
        <div className="ul-eval-question-text">{question}</div>
        <div className="ul-eval-answer-box">{answer}</div>

        {steps?.map((step, i) => (
          <div className="ul-step-row" key={i}>
            <div
              className={`ul-step-icon-sm ${step.ok ? "ul-step-ok" : "ul-step-err"}`}
              aria-hidden="true"
            >
              {step.ok ? "✓" : "✗"}
            </div>
            <div>
              <div className="ul-step-text-sm">{step.text}</div>
              {step.note ? <div className="ul-step-err-note">{step.note}</div> : null}
            </div>
          </div>
        ))}

        {criteria?.map((c, i) => (
          <CriteriaRow key={i} label={c.label} widthPct={c.widthPct} score={c.score} fill={c.fill} />
        ))}

        <div className="ul-eval-tip">{tip}</div>
      </div>
    </BrowserFrame>
  );
}

export default EvalCard;
